
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    images: { type: Array, required: true },
    rounded: { type: Boolean, required: true },
  },
});
